/** Trims strings in arrays and plain objects before JSON serialization, without mutating the body. */
export function serializeRequestBody(body: object | string): string | undefined {
    return JSON.stringify(trimStringValues(body));
}

function trimStringValues(value: unknown): unknown {
    if (typeof value === 'string') {
        return value.trim();
    }

    if (Array.isArray(value)) {
        return value.map(trimStringValues);
    }

    if (isPlainObject(value)) {
        return Object.fromEntries(
            Object.entries(value).map(([key, entry]) => [key, trimStringValues(entry)])
        );
    }

    // Leave class instances intact so JSON.stringify retains their serialization behavior.
    return value;
}

function isPlainObject(value: unknown): value is Record<string, unknown> {
    if (value === null || typeof value !== 'object') {
        return false;
    }

    const prototype = Object.getPrototypeOf(value);
    return prototype === Object.prototype || prototype === null;
}
